import { render, staticRenderFns } from "./apartment-price-card.vue?vue&type=template&id=79b583e2&scoped=true&"
import script from "./apartment-price-card.ts?vue&type=script&lang=ts&"
export * from "./apartment-price-card.ts?vue&type=script&lang=ts&"
import style0 from "./apartment-price-card.scss?vue&type=style&index=0&id=79b583e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b583e2",
  null
  
)

export default component.exports